import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/veiculos/listar/form_edit'
import Head from '../../../../components/head'


function EditarDVeiculosScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Veículo" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarDVeiculosScreen;